import React from "react";
import SmartScanSelfieCapture from "../SmartScanSelfieCapture/SmartScanSelfieCapture";
import { smartScanCategory } from "../../constants";
import useGetSmartScanSelfieCaptureProgress from "../CustomHooks/useGetSmartScanSelfieCaptureProgress";
import {
  getSmartScanImageBasedOnCaptureOption,
  getSmartScanInstructionsBasedOnCaptureOption
} from "../../helpers/smartScanUtils";

const SmartScanUpperArchPage = () => {
  const smartScanState = useGetSmartScanSelfieCaptureProgress();

  return (
    <>
      <SmartScanSelfieCapture
        state={smartScanState}
        previousPagePath={"/smart-scan-instruction"}
        nextPagePath={
          smartScanState?.isAuthenticated
            ? "/smart-scan-upper-arch-confirm"
            : "/smart-scan-upper-arch-confirm-no-auth"
        }
        category={smartScanCategory.UpperArch}
        poseImage={getSmartScanImageBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.UpperArch
        )}
        instruction={getSmartScanInstructionsBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.UpperArch
        )}
      />
    </>
  );
};

export default SmartScanUpperArchPage;
